<template>
  <div :class="['modalContainer', getModalStateClass]" @mousedown.self="closeModal()">
    <div :class="style_class ? style_class : 'modalKanban'" style="padding: 40px;">
      <div class="header">
        <slot name="header" />
      </div>

      <div class="body">
        <slot name="body" />
      </div>

      <div class="footer">
        <slot name="footer" />
      </div>
    </div>
  </div>
</template>
<script>


export default {
  name: 'Modal',
  props: {
    isOpen: Boolean,
    style_class: null
  },
  emits: ['close'],
  methods:{
    closeModal(){
      this.$emit('close')
    }
  },
  computed: {
    getModalStateClass() {
      return this.isOpen ? 'opened' : 'closed'
    }
  }
}
</script>

<style scoped>
.modalContainer {
  backdrop-filter: blur(2px);
  color: #858796;
  @apply w-full min-h-full fixed top-0 left-0 bg-zinc-700/10 flex justify-center p-2 pt-[10rem]
}

.modalContainer .modalKanban {
  @apply w-full sm:max-w-[55rem] flex flex-col gap-4 p-4 bg-white shadow-xl rounded-lg h-max
}

.modalContainer .modalKanban .header {
  @apply border-b border-zinc-700/70
}

.modalContainer .modalAddEditColumn {
  @apply w-full sm:max-w-[30rem] flex flex-col gap-4 p-4 bg-white shadow-xl rounded-lg h-max
}

.modalContainer .modalAddEditColumn .header {
  @apply border-b border-zinc-700/70
}

.closed {
  @apply scale-0 -z-50 opacity-0
}

.opened {
  @apply z-[99] scale-100 opacity-100
}

.modalSm {
  backdrop-filter: blur(2px);
  color: #858796;
  max-width:430px !important;
  min-width:420px !important;
  @apply sm:max-w-[55rem] flex flex-col gap-4 p-4 bg-white shadow-xl rounded-lg h-max
}
</style>
